export interface Itokens {
  address: string;
  symbol: string;
}

const tokenRepo: Itokens[] = [
  { address: "0x9A676e781A523b5d0C0e43731313A708CB607508", symbol: "EXMP" },
];
export default tokenRepo;
